import React from 'react';
import style from './style.module.scss';
import { ErrorAwareLabel } from '../../error-aware-label';

export interface LabeledFieldCommonProps {
    label?: React.ReactNode;
    helperText?: string;
    hasError?: boolean;
    className?: string;
}

export interface LabeledFieldProps extends LabeledFieldCommonProps {
    children: React.ReactNode;
}

export const LabeledField = ({
    label,
    helperText,
    hasError,
    className,
    children,
}: LabeledFieldProps) => {
    return (
        <div className={`${style.labeled_field} ${className || ''}`}>
            {label && (
                <div className={style.label_wrapper}>
                    <ErrorAwareLabel text={label} hasError={hasError} />
                </div>
            )}
            <div className={style.field_wrapper}>{children}</div>
            {helperText && (
                <label className={`${style.helper_text} footnote_description`}>
                    {helperText}
                </label>
            )}
        </div>
    );
};
